export default "__VITE_ASSET__4W_Y3JK7__"